<template>
  <div class="min-wrap">
    <v-container class="pt-4 pb-1">
      <div class="status text-center">
        <img
          v-if="
            $route.params.status == statusType.success ||
              $route.params.status == statusType.letspay ||
              $route.params.status == statusType.wait
          "
          src="@/assets/img/icon/success.svg"
          alt
        />
        <img v-else src="@/assets/img/icon/fail.svg" alt />
        <div class="text">
          {{
            $route.query.couponType
              ? statusStringCoupon[$route.params.status]
              : statusString[$route.params.status]
          }}
        </div>
      </div>
    </v-container>
    <v-container class="text-center  pb-6">
      <p class="wording-text" v-if="$route.params.status == statusType.success">
        感謝您的付款
        <br />
        5-10分鐘後可至票券匣確認您的票券
      </p>
      <p
        class="wording-text"
        v-else-if="$route.params.status == statusType.error"
      >
        很抱歉，交易過程中出了點問題，請您稍後再試
      </p>
      <p
        v-else-if="$route.params.status == statusType.wait"
        class="wording-text"
      >
        請於{{ $route.params.expired }}前完成付款。
      </p>
    </v-container>
    <v-container class="pt-0 px-4">
      <div
        class="wording-text pb-4"
        v-if="$route.params.status == statusType.success"
      >
        <v-divider class="pb-4" />
        為保障彼此之權益，收到您的訂單後本公司仍保有決定是否接受訂單及出貨與否之權利。
        <br />
        若您對本次交易有任何問題，也可透過訂單內的聯絡客服隨時與我們聯繫，謝謝。
      </div>
      <div v-if="$route.params.status == statusType.success">
        <v-btn class="v-btn-primary mb-4" color="primary" @click="goOrderList">
          前往票券匣
        </v-btn>
        <v-btn
          class="v-btn-primary"
          color="primary"
          @click="goHomePage"
          outlined
        >
          繼續逛逛
        </v-btn>
      </div>
      <div v-if="$route.params.status == statusType.error">
        <v-btn
          class="v-btn-primary mb-4"
          color="primary"
          @click="goBackProduct()"
        >
          回到商品頁
        </v-btn>
        <v-btn
          class="v-btn-primary"
          outlined
          color="primary"
          @click="goHomePage"
        >
          返回首頁
        </v-btn>
      </div>
      <div v-if="$route.params.status == statusType.wait">
        <v-btn class="v-btn-primary mb-3" color="primary" @click="goDeeplink">
          前往付款
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
const statusType = {
  success: 'success',
  error: 'error',
  letspay: 'letspay',
  wait: 'wait',
}
const statusString = {
  success: '交易成功',
  error: '交易失敗',
  wait: '等待付款中',
}

export default {
  name: 'PaymentResult',
  components: {},
  data() {
    return {
      statusType,
      statusString,
      statusStringCoupon: {
        success: '索取成功',
        error: '索取失敗',
      },
      orderAmount: 0,
      orderNo: '',
      deeplink: '',
    }
  },
  created() {
    this.orderAmount = this.$route.query.amount
    this.orderNo = this.$route.query.orderNo
    if (typeof window.host_renewTokenInfo != 'undefined') {
      window.host_renewTokenInfo()
    }
    if (this.$route.params.status == this.statusType.success) {
      localStorage.removeItem('shoppingCart')
    }
  },
  methods: {
    myBack() {
      history.pushState(null, null, document.URL)
    },
    goDeeplink() {
      if (this.deeplink) {
        if (typeof window.host_deeplink != 'undefined') {
          window.host_deeplink(this.deeplink)
        } else {
          const tempwindow = window.open('url', '_blank')
          tempwindow.location = this.deeplink
        }
      } else {
        this.$bus.$emit('callAllert', {
          messageContent: '發生了一點錯誤！',
          callback: () => {
            if (localStorage.getItem('source') === 'e7g') {
              window.location = process.env.VUE_APP_E7G_HOME
            } else {
              this.$router.replace({ name: 'home' })
            }
          },
        })
      }
    },
    goBackProduct() {
      const cartJson = localStorage.getItem('shoppingCart')
      if (cartJson) {
        const cart = JSON.parse(cartJson)
        this.$router.replace({ name: 'product', params: { id: cart.id } })
      } else {
        this.goHomePage()
      }
    },
    goHomePage() {
      if (localStorage.getItem('source') === 'e7g') {
        window.location = process.env.VUE_APP_E7G_HOME
      } else {
        this.$router.replace({ name: 'home' })
      }
    },
    goOrderList() {
      window.location = process.env.VUE_APP_LINK_TICKETS
    },
  },
  computed: {
    errReason() {
      if (this.$route.params.err) {
        switch (this.$route.params.err.code) {
          case 8020:
            return '信用卡資訊有誤'
          case 8030:
            return '信用卡資訊有誤'
          case 8060:
            return '庫存不足'
          default:
            return this.$route.params.err.message || '付款失敗'
        }
      } else {
        return '付款失敗'
      }
    },
    useMock() {
      return process.env.VUE_APP_USE_DEV == 'true'
    },
  },
  mounted() {
    history.pushState(null, null, document.URL)
    if (this.$route.params.status == this.statusType.letspay) {
      if (typeof window.host_deeplink != 'undefined') {
        console.log('host_deeplink:' + this.$route.query.m)
        window.host_deeplink(this.$route.query.m)
      } else {
        window.open(this.$route.query.m)
        console.log(
          'can not find host_deeplink function, val:' + this.$route.query.m
        )
      }
    } else if (this.$route.params.status == this.statusType.wait) {
      this.deeplink = this.$route.params.deeplink
      // this.goDeeplink()
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.myBack, false)
    window.onpopstate = () => {}
  },
}
</script>

<style scoped lang="scss">
.min-wrap {
  min-height: 100vh;
}
::v-deep {
  .container {
    background-color: #ffffff;
  }

  .v-btn-primary {
    &.v-btn--outlined {
      .v-btn__content {
        color: #1da7fc;
      }
    }
  }
}
.status .text {
  font-size: 22px;
  font-weight: bold;
  color: #292929;
}
.wording-text {
  font-size: 14px;
  color: #989898;
  line-height: 22px;
}
</style>
